import { useNavigate } from 'react-router-dom';

import { SimpleCard } from '@hivebrite/design-system/SimpleCard';

import { useForumContext } from 'hb-react/frontoffice/apps/Forum/contexts/ForumContext';
import { useCanCreateDiscussion } from 'hb-react/frontoffice/apps/Forum/hooks/useCanCreateDiscussion';

const WidgetEmpty = () => {
  const navigate = useNavigate();
  const { configUrls } = useForumContext();
  const canCreateDiscussion = useCanCreateDiscussion();

  return (
    <SimpleCard
      title={s__('Forum|Popular discussions')}
      description={s__(
        'Forum|Most popular discussions from top categories will show up here',
      )}
      faIconProps={{ iconName: 'bullhorn' }}
      buttonProps={
        canCreateDiscussion
          ? {
              children: s__('Forum|New discussion'),
              onClick: () => navigate(configUrls.newDiscussionUrl()),
            }
          : undefined
      }
    />
  );
};

export default WidgetEmpty;
